/* eslint-disable indent */
import template from './activationHourServices.html';
import controller from './activationHourServices.controller';

const activationHourServicesComponent = {
    restrict: 'E',
    bindings:
        {
            setDays: '=',
            getDays: '=',
            getDaysWithPrepareTime: "=",
            office: '='
        },
    controller,
    template
};

export default activationHourServicesComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/activationHourServices/activationHourServices.component.js
 **/